/**
 * Centralized business / brand configuration for Diaz Brothers Construction LLC.
 * All hard-coded brand details should pull from here.
 */

export const siteConfig = {
  name: "Diaz Brothers Construction LLC",
  shortName: "Diaz Brothers",
  legalName: "Diaz Brothers Construction LLC",
  owner: "Loriel Fernando Diaz",
  tagline: "Painting, Waterproofing & Remodeling Across the Denver Metro",
  description:
    "Diaz Brothers Construction LLC delivers residential and commercial interior & exterior painting, facade waterproofing, remodeling, drywall, and tile installation across Highlands Ranch, Littleton, Parker, Castle Pines, Evergreen, Longmont, Loveland and the surrounding Colorado communities. Bilingual crew — English & Español. Free estimates.",

  domain: "diazbrothersconstructionllc.com",
  url: "https://diazbrothersconstructionllc.com",

  /** Primary voice line — where calls are forwarded. */
  phone: "(720) 586-3832",
  phoneHref: "tel:+17205863832",

  /** Text-message line. */
  smsPhone: "(915) 234-3558",
  smsHref: "sms:+19152343558",

  email: "diazbrotherscllc@gmail.com",
  emailHref: "mailto:diazbrotherscllc@gmail.com",

  address: {
    street: "3442 Et. Country",
    city: "Highlands Ranch",
    state: "CO",
    postalCode: "80126",
    region: "Douglas County",
    serviceRadius: "75 miles",
    full: "3442 Et. Country, Highlands Ranch, CO 80126",
  },

  /** EIN on file — used for A2P/10DLC messaging registration, not displayed. */
  ein: "41-3085822",

  hours: {
    summary: "Mon–Fri · 9 AM – 5 PM",
    days: "Monday – Friday",
    time: "9:00 AM – 5:00 PM",
    note: "Saturday by appointment",
  },

  languages: ["English", "Español"],

  /**
   * Flip to `true` once the client's own job photos are in
   * /public/assets/gallery — the Gallery page then renders the photo grid
   * instead of the "coming soon" panel.
   */
  galleryReady: true,

  /** Transparent-background logo (WebP with alpha, keyed from the supplied JPEG). */
  logo: "/diaz-brothers-logo.webp",
  /** Social preview keeps the flat JPEG — OG images can't use transparency. */
  ogImage: "/diaz-brothers-logo.jpeg",
  favicon: "/favicon.ico",

  social: {
    instagram: null,
    facebook: null,
    tiktok: "https://www.tiktok.com/@fernandococinacubana",
    yelp: null,
  },

  discount: {
    label: "15% Off for New Clients",
    short: "15% New Client Discount",
    description:
      "New customers save 15% on their first project with Diaz Brothers Construction. Refer a friend or neighbor and take 10% off your next job.",
    referral: "10% Referral Discount",
  },

  /** Third-party widget IDs — Diaz Brothers LeadConnector / Reputation Hub sub-account. */
  widgets: {
    chatWidgetId: "6a68b4865aa03d54c0eabb68" as string | null,
    chatLoaderSrc: "https://widgets.leadconnectorhq.com/loader.js",
    chatResourcesUrl: "https://widgets.leadconnectorhq.com/chat-widget/loader.js",

    reviewScriptSrc: "https://reputationhub.site/reputation/assets/review-widget.js",
    reviewIframeSrc:
      "https://reputationhub.site/reputation/widgets/review_widget/94BWOwsikdSmYvsGYcBz?widgetId=6a691ac095eb4d4671a6ebbd" as string | null,
    reviewRequestUrl: null as string | null,

    formIframeSrc: "https://link.systemic-digital.net/widget/form/BvOZbKvvrHyPNeYO97nI" as
      | string
      | null,
    formScriptSrc: "https://link.systemic-digital.net/js/form_embed.js",
    formId: "BvOZbKvvrHyPNeYO97nI" as string | null,
    formName: "Website Form",
    formHeight: 754,
  },

  serviceAreas: [
    "Highlands Ranch, CO",
    "Littleton, CO",
    "Centennial, CO",
    "Lone Tree, CO",
    "Castle Pines, CO",
    "Parker, CO",
    "Ken Caryl, CO",
    "Morrison, CO",
    "Evergreen, CO",
    "Genesee, CO",
    "Conifer, CO",
    "Sedalia, CO",
    "Franktown, CO",
    "Larkspur, CO",
    "Elizabeth, CO",
    "Longmont, CO",
    "Loveland, CO",
  ],
} as const;

export type SiteConfig = typeof siteConfig;
